import styled from 'styled-components';

export default function LivePlaybackButton({ onPlay }: { onPlay: () => void }) {
  return <PlayButton type="button" onClick={onPlay}>
    <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M8 5v14l11-7z" fill="currentColor" />
    </svg>
    방송 재생
  </PlayButton>;
}

const PlayButton = styled.button`
  position: absolute;
  z-index: 60;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 52px;
  padding: 12px 20px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 28px;
  background: rgba(20, 18, 28, 0.9);
  color: white;
  font: inherit;
  font-size: 16px;
  white-space: nowrap;
  cursor: pointer;
  &:focus-visible { outline: 3px solid white; outline-offset: 4px; }
  &:active { background: rgba(55, 50, 70, 0.95); }
`;
